import { render, staticRenderFns } from "./dataStatistics.vue?vue&type=template&id=0abb912d&scoped=true&"
import script from "./dataStatistics.vue?vue&type=script&lang=js&"
export * from "./dataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./dataStatistics.vue?vue&type=style&index=0&id=0abb912d&lang=less&scoped=true&"
import style1 from "./dataStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb912d",
  null
  
)

export default component.exports